import React from "react";
import { useDropzone } from "react-dropzone";
import {
  dropzone_wrapper,
  active,
  dropzone_icon,
  dropzone_text,
  dropzone_hint,
  dropzone_formats,
  format_badge,
} from "../../../styles/modules/palette_from_image.module.css";

// Textos multiidioma
const TEXTS = {
  es: {
    dropHere: "¡Suelta la imagen aquí!",
    dragOrClick: "Arrastra una imagen aquí",
    orClick: "o haz clic para seleccionar",
    formats: "Formatos soportados",
  },
  en: {
    dropHere: "Drop the image here!",
    dragOrClick: "Drag an image here",
    orClick: "or click to select",
    formats: "Supported formats",
  },
  pt: {
    dropHere: "Solte a imagem aqui!",
    dragOrClick: "Arraste uma imagem aqui",
    orClick: "ou clique para selecionar",
    formats: "Formatos suportados",
  },
  fr: {
    dropHere: "Déposez l'image ici!",
    dragOrClick: "Faites glisser une image ici",
    orClick: "ou cliquez pour sélectionner",
    formats: "Formats supportés",
  },
  de: {
    dropHere: "Lass das Bild hier fallen!",
    dragOrClick: "Ziehen Sie ein Bild hierher",
    orClick: "oder klicken Sie, um auszuwählen",
    formats: "Unterstützte Formate",
  },
};

function Dropzone({ onDrop, accept, locale }) {
  const texts = TEXTS[locale] || TEXTS.es;

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    multiple: false,
  });

  return (
    <div
      className={`${dropzone_wrapper} ${isDragActive ? active : ""}`}
      {...getRootProps()}
    >
      <input {...getInputProps()} />

      {/* Icono */}
      <svg
        className={dropzone_icon}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        {isDragActive ? (
          <>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </>
        ) : (
          <>
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </>
        )}
      </svg>

      {/* Texto */}
      {isDragActive ? (
        <p className={dropzone_text}>{texts.dropHere}</p>
      ) : (
        <>
          <p className={dropzone_text}>{texts.dragOrClick}</p>
          <p className={dropzone_hint}>{texts.orClick}</p>
        </>
      )}

      {/* Formatos */}
      {!isDragActive && (
        <div className={dropzone_formats}>
          <span className={format_badge}>JPG</span>
          <span className={format_badge}>PNG</span>
          <span className={format_badge}>WEBP</span>
          <span className={format_badge}>GIF</span>
        </div>
      )}
    </div>
  );
}

export default Dropzone;
